"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var bind_1 = require("../bind");
var SidebarToggle = /** @class */ (function (_super) {
    tslib_1.__extends(SidebarToggle, _super);
    function SidebarToggle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            sidebarOpen: false,
        };
        return _this;
    }
    SidebarToggle.prototype.toggleSidebar = function () {
        this.setState({ sidebarOpen: !this.state.sidebarOpen }, function () {
            // This needs to be global state for mobile and to be preserved
            // when routing to a new nested route.
            document.body.classList.toggle('facet-sidebar-open');
            document.body.classList.toggle('mobile-panel-open');
        });
    };
    SidebarToggle.prototype.renderOpen = function () {
        return (React.createElement("a", { className: "grid-filter__action", onClick: this.toggleSidebar, rel: "nofollow" }, I18n.t('commons.filters.filterResults')));
    };
    SidebarToggle.prototype.renderClose = function () {
        return (React.createElement("a", { className: "button size-90", onClick: this.toggleSidebar }, I18n.t('commons.filters.closePanel')));
    };
    SidebarToggle.prototype.render = function () {
        if (this.props.open && this.props.close) {
            throw new Error('toggle can either be for opening or for closing, not both');
        }
        if (this.props.open) {
            return this.renderOpen();
        }
        if (this.props.close) {
            return this.renderClose();
        }
    };
    SidebarToggle.defaultProps = {
        open: false,
        close: false,
    };
    tslib_1.__decorate([
        bind_1.default
    ], SidebarToggle.prototype, "toggleSidebar", null);
    return SidebarToggle;
}(React.Component));
exports.default = SidebarToggle;
//# sourceMappingURL=sidebar_toggle.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/sidebar_toggle.js
// module id = ZzIO
// module chunks = 0 1 2 3 9 10 14 20